import * as React from 'react'
import {TableCell} from "@mui/material";
import PriceDiscountImageSkuBlock from "../../../../../../@components/ImageSkuBlock";


export default function PricingImageSkuCell({ skuID }) {
	return <TableCell>
		<PriceDiscountImageSkuBlock skuID={skuID}/>
	</TableCell>
}